import CIMSymbol from '@arcgis/core/symbols/CIMSymbol';

export const ARROW_CIM_SYMBOL = new CIMSymbol({
  data: {
    type: 'CIMSymbolReference',
    symbol: {
      type: 'CIMLineSymbol',
      symbolLayers: [
        {
          // arrow symbol
          type: 'CIMVectorMarker',
          enable: true,
          size: 12,
          markerPlacement: {
            type: 'CIMMarkerPlacementAtExtremities',
            // https://github.com/Esri/cim-spec/blob/master/docs/v2/CIMSymbols.md#enumeration-extremityplacement
            extremityPlacement: 'JustEnd',
            keepUpright: false
          },
          frame: {
            xmin: -5,
            ymin: -5,
            xmax: 0,
            ymax: 5
          },
          markerGraphics: [
            {
              type: 'CIMMarkerGraphic',
              geometry: {
                rings: [
                  [
                    [-8, -5.47],
                    [-8, 5.6],
                    [1.96, -0.03],
                    [-8, -5.47]
                  ]
                ]
              },
              symbol: {
                // red fill for the arrow symbol
                type: 'CIMPolygonSymbol',
                symbolLayers: [
                  {
                    type: 'CIMSolidFill',
                    enable: true,
                    color: [0, 120, 183, 255]
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  }
});
